var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.231.382a.385.385,0,0,1,.769,0V2.677a.385.385,0,0,1-.769,0V.382ZM.769.382a.385.385,0,0,1,.769,0V2.677a.385.385,0,0,1-.769,0V.382Z",
    transform: "translate(-0.022)",
    fill: "#f18904"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1368 -566)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8235 8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667,14A2.624,2.624,0,0,1,0,11.421V1.1A1.125,1.125,0,0,1,1.143,0H14.857A1.125,1.125,0,0,1,16,1.1V11.421A2.624,2.624,0,0,1,13.333,14Zm-1.9-2.579a1.875,1.875,0,0,0,1.9,1.842H13.333a1.874,1.874,0,0,0,1.9-1.842V3.684H.762ZM.762,1.1V2.947H15.237V1.1a.374.374,0,0,0-.381-.368H1.143A.375.375,0,0,0,.762,1.1Z",
    transform: "translate(9603 -7554)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9606.022 -7556)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    transform: "translate(-4.022 -4)",
    fill: "#fd9926"
  }))), /*#__PURE__*/React.createElement("line", {
    x2: 4.506,
    y2: 4.506,
    transform: "translate(1373.747 574.247)",
    fill: "none",
    stroke: "#fd9926",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.506,
    x2: 4.506,
    transform: "translate(1373.747 574.247)",
    fill: "none",
    stroke: "#fd9926",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelEvent);
export default __webpack_public_path__ + "static/media/cancel_event.32a9c816731ba93e5b590121ddc15bab.svg";
export { ForwardRef as ReactComponent };